/* eslint-disable @next/next/no-img-element */
import React from "react";
import { Button } from "@mui/material";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import styles from "@/src/styles/home.module.css";

function AccurateResults(props: { title?: string }) {
  return (
    <Box sx={{ py: 0, padding: { xs: "60px 0 0", sm: "80px 0 0" } }}>
      <Container maxWidth={false} className={"containerWidth"}>
        <div className={styles.accurateResultBox}>
          <div className={styles.accurateData}>
            <h1 className={styles.sendResultTitle}>
              Lorem ipsum dolor sit amets
            </h1>

            <div className={styles.accurateDataList}>
              <div className={styles.accurateItem}>
                <div className={styles.accurateItemIcon}>
                  <img src={"/icons/exam-icon.svg"} alt={"placeholder"} />
                </div>
                <div className={styles.accurateItemData}>
                  <h4 className={styles.accurateItemTitle}>
                    Lorem ipsum <span>dolor sit</span>
                  </h4>
                  <div className={styles.accurateItemText}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  </div>
                </div>
              </div>

              <div className={styles.accurateItem}>
                <div className={styles.accurateItemIcon}>
                  <img src={"/icons/exam-icon.svg"} alt={"placeholder"} />
                </div>
                <div className={styles.accurateItemData}>
                  <h4 className={styles.accurateItemTitle}>
                    Lorem ipsum <span>dolor sit</span>
                  </h4>
                  <div className={styles.accurateItemText}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  </div>
                </div>
              </div>

              <div className={styles.accurateItem}>
                <div className={styles.accurateItemIcon}>
                  <img src={"/icons/exam-icon.svg"} alt={"placeholder"} />
                </div>
                <div className={styles.accurateItemData}>
                  <h4 className={styles.accurateItemTitle}>
                    Lorem ipsum <span>dolor sit</span>
                  </h4>
                  <div className={styles.accurateItemText}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  </div>
                </div>
              </div>

              <div className={styles.accurateItem}>
                <Button
                  variant="contained"
                  sx={{
                    display: "flex",
                    gap: "15px",
                    height: "50px",
                    boxShadow: "none",
                    backgroundColor: "#3f3f3f",
                    fontSize: "15px",
                    fontWeight: 600,
                    borderRadius: "8px",
                    textTransform: "none",
                    "&.MuiButtonBase-root:hover": {
                      backgroundColor: "#878b93",
                    },
                  }}
                >
                  <img src={"/icons/play.svg"} alt="video" /> OPTION
                </Button>
              </div>
            </div>
          </div>
          <div className={styles.accurateImage}>
            <img src={"/images/placeholder.png"} alt={"placeholder"} />
          </div>
        </div>
      </Container>
    </Box>
  );
}

export default AccurateResults;
